// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"2a58cf9b","453":"05203747","582":"7a17327a"}[chunkId] + ".chunk.js";
};